// Classic › venues: the venues list and venue page copy (#1119). The
// "Venues" title, the league fallback name and the shared venue headings
// come from site-core.
import { plural } from '../../../plural'

const en = {
  /** Above the grid: "3 Venues". */
  count: (n: number) => plural(n, { one: `${n} Venue`, other: `${n} Venues` }),
  emptyTitle: 'No Venues Yet',
  emptyBody: 'No venues have been added for this league.',
  /** Courts, fields or pitches inside a venue: deliberately generic. */
  spaces: (n: number) => plural(n, { one: `${n} space`, other: `${n} spaces` }),
  viewOnMap: 'View on map',
  allVenues: 'All Venues',
  notFoundTitle: 'Venue Not Found',
  notFoundBody: "This venue doesn't exist or is no longer available.",
  browseAll: 'Browse all venues',
}

export default en
